import React, { Component } from 'react';
import TermsOfUseComponent from '../components/termsOfuseComponent';
import {getTermsOfUse,updateTermsOfUse, updateAcceptTermsOfUse, updateTermsOfUseHeader, updateTermsOfUseSubHeader} from '../action/termsOfuseAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

export class TermsOfUseContainer extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.props.actions.getTermsOfUse();
    }
    getAllData = () =>{
        this.props.actions.getTermsOfUse(
            this.props.dispatch
        )
    }
    updateTermsOfUseDetails =(data) =>{
        this.props.actions.updateTermsOfUse(
            data, 
            this.props.dispatch
        )
    }
    updateAcceptTermsOfUseData = (data) =>{
        this.props.actions.updateAcceptTermsOfUse(
            data,
            this.props.dispatch
        )
    }
    updateTermsOfUseHeaderData = (data) => {
        this.props.actions.updateTermsOfUseHeader(
            data,
            this.props.dispatch
        )
    }
    updateTermsOfUseSubHeaderData = (data) => {
        this.props.actions.updateTermsOfUseSubHeader(
            data,
            this.props.dispatch
        )
    }
    render() {
        return (<div>
            <TermsOfUseComponent
                getTermsOfUseDetails={this.props.termsOfUseDetails} 
                updateTermsOfUseDetails = {this.updateTermsOfUseDetails}
                updateAcceptTermsOfUseFunc = {this.updateAcceptTermsOfUseData}
                updateTermsOfUseHeaderFunc = {this.updateTermsOfUseHeaderData}
                updateTermsOfUseSubHeaderFunc = {this.updateTermsOfUseSubHeaderData}
                getAllTermsData = {this.getAllData}
            >
            </TermsOfUseComponent>
        </div>)

    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getTermsOfUse,
            updateTermsOfUse,
            updateAcceptTermsOfUse,
            updateTermsOfUseHeader,
            updateTermsOfUseSubHeader
        },
            dispatch)
    };
}

function mapStateToProps({ TermsOfUseReducer}) {
    console.log(TermsOfUseReducer)
    return {
        termsOfUseDetails: {
            errorCode : TermsOfUseReducer.errorCode,
            statusCode : TermsOfUseReducer.statusCode,
            termsConditionSetting : TermsOfUseReducer.termsConditionSetting,
            updatedValue : TermsOfUseReducer.updatedValue
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TermsOfUseContainer));